// This script adjusts the grid template columns for media-text blocks within grid-style columns blocks to ensure proper layout.

document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('.wp-block-columns.is-style-grid .wp-block-media-text')
    .forEach((block) => {
      const style = block.style.gridTemplateColumns;
      const parts = style.split(' ');
      const firstPercent = parts[0];
      block.style.gridTemplateColumns = `auto calc(100% - ${firstPercent})`;
    });
});
